const reducer = (state, action) => {
  switch (action.type) {
    case 'SAVE_CLIENT':
      return {
        ...state,
        client: action.payload,
      };
    case 'SAVE_INFO':
      return {
        ...state,
        plans: action.payload[1].plan,
      };
    case 'ADD_LEAD_DATA':
      return {
        ...state,
        leadData: action.payload,
      };
    case 'SAVE_PLAN_SELECTED':
      return {
        ...state,
        planSelected: action.payload,
      };
    case 'SAVE_INSURED_LIST':
      return {
        ...state,
        insuredList: action.payload,
      };
    case 'SAVE_COVERAGE_SELECTED':
      return {
        ...state,
        coverageAditional: action.payload,
      };
    case 'SAVE_ID_QUOTE':
      return {
        ...state,
        idQuote: action.payload,
      };
    case 'SAVE_DPS':
      return {
        ...state,
        dps: action.payload,
      };
    case 'SAVE_ADDRESS':
      return {
        ...state,
        adresss: action.payload,
      };
    case 'SAVE_PLANS_FLEX':
      return {
        ...state,
        plansFlex: action.payload,
      };
    case 'SAVE_PLANS_FLEX_DISCOUNT':
      return {
        ...state,
        plansFlexDiscount: action.payload,
      };
    case 'SAVE_PLAN_FLEX_SELECTED':
      return {
        ...state,
        planFlexSelected: action.payload,
      };
    case 'SAVE_QUOTE':
      return {
        ...state,
        quote: action.payload,
      };
    case 'SAVE_SESSION':
      return {
        ...state,
        sessionId: action.payload,
      };
    case 'SAVE_DISCOUNT':
      return {
        ...state,
        discount: action.payload,
      };
    case 'MOSTRAR_CONTACTO':
      return {
        ...state,
        globalBotonesVisibles: action.payload,
      };
    case 'SHOW_FIXED_BAR':
      return {
        ...state,
        showFixedBarQuote: action.payload,
      };
    case 'NON_EXISTENT_DOCUMENT':
      return {
        ...state,
        nonExistentDocument: action.payload,
      };
    case 'SET_QUOTATION_QUOTE': {
      return {
        ...state,
        subscriptionQuote: action.payload,
      };
    }
    case 'SET_DEPARTMENT': {
      return {
        ...state,
        deparment: action.payload,
        departmentLoaded: true,
      };
    }
    case 'SET_EXP_CAMPAIGN_DAYS': {
      return {
        ...state,
        experiments: {
          campaignDays: true,
        },
      };
    }
    case 'SET_EXPERIMENT_CYBER': {
      return {
        ...state,
        experiments: {
          ...state.experiments,
          experimentCyber: action.payload,
        },
      };
    }
    case 'CLEAN_EXPERIMENT_CYBER': {
      return {
        ...state,
        experiments: {
          ...state.experiments,
          experimentCyber: {
            isActive: false,
            startDate: '',
            endDate: '',
          },
        },
      };
    }
    case 'SET_EXP_NEW_PRICE': {
      return {
        ...state,
        experiments: {
          newPrice: true,
        },
      };
    }
    default:
      return state;
  }
};
export default reducer;
